<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="800" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-3 white--text py-2">
          Subir documentos
          <v-spacer />
          <v-btn color="white" :loading="loading" text @click="dialog = false">X</v-btn>
        </v-card-title>

        <v-card-text>
          <p v-if="inscripcion" class="text-center pt-2">
            <b>
              {{ inscripcion.estudiante.nombres }}
              {{ inscripcion.estudiante.pri_apellido }}
              {{ inscripcion.estudiante.seg_apellido }}
            </b>
          </p>

          <!-- BOTÓN PARA VER DOCUMENTOS CARGADOS -->
          <div class="text-center mb-4" v-if="cargados.length">
            <v-btn color="orange" :loading="loading" small outlined @click="openVer()">
              <v-icon left>mdi-file-document</v-icon>
              Ver documentos cargados ({{ cargados.length }})
            </v-btn>
          </div>
          <div v-if="datos.length" class="text-center my-4">
          <!-- STEER VERTICAL -->
          <v-stepper v-model="activeStep" vertical>
            <!-- PASOS -->
            <template v-for="(d, i) in datos">
              <v-stepper-step
                :key="`${i}-step`"
                :complete="activeStep > i + 1"
                :step="i + 1"
                editable
              >
                {{ d.nombre }}
                <small v-if="estaCargado(d.id)" class="green--text">
                  ✓ Ya cargado
                </small>
                <small v-else>
                  Complete los datos requeridos
                </small>
              </v-stepper-step>

              <!-- CONTENIDO DE CADA PASO -->
              <v-stepper-content
                :key="`${i}-content`"
                :step="i + 1"
              >
                <!-- INFORMACIÓN DEL DOCUMENTO CARGADO -->
                <v-alert
                  v-if="estaCargado(d.id)"
                  type="success"
                  class="mb-4"
                >
                  <strong>Documento ya cargado</strong>
                  <br>
                  <small>Estado: {{ obtenerEstado(d.id) }}</small>
                </v-alert>

                <v-card flat class="mb-4">
                  <v-card-text>
                    <!-- Input de archivo -->
                    <v-file-input 
                      accept=".pdf,.png,.jpg,.jpeg" 
                      label="Seleccione el archivo:"
                      @change="setterFile($event, d)" 
                      :disabled="estaCargado(d.id)"
                    />
                    
                    <!-- Vista previa -->
                    <div v-if="d.previewUrl" class="mt-2">
                      <v-img 
                        v-if="d.archivo && d.archivo.type.startsWith('image/')" 
                        :src="d.previewUrl" 
                        max-height="200"
                        contain 
                        class="my-2" 
                      />
                      <div v-else-if="d.archivo && d.archivo.type === 'application/pdf'" class="my-2">
                        <iframe 
                          :src="d.previewUrl" 
                          width="100%" 
                          height="200"
                          style="border: 1px solid #ccc; border-radius: 4px"
                        ></iframe>
                      </div>
                    </div>

                    <!-- Vista del documento ya cargado -->
                    <div v-if="estaCargado(d.id) && obtenerArchivoUrl(d.id)" class="mt-2">
                      <p class="text-caption grey--text">Documento actual:</p>
                      <v-img 
                        v-if="obtenerTipoArchivo(d.id) === 'image'" 
                        :src="obtenerArchivoUrl(d.id)" 
                        max-height="200"
                        contain 
                        class="my-2" 
                      />
                      <div v-else-if="obtenerTipoArchivo(d.id) === 'pdf'" class="my-2">
                        <iframe 
                          :src="obtenerArchivoUrl(d.id)" 
                          width="100%" 
                          height="200"
                          style="border: 1px solid #ccc; border-radius: 4px"
                        ></iframe>
                      </div>
                    </div>

                    <!-- Campos de datos dinámicos -->
                    <div v-for="(p, j) in d.plantillaDatos" :key="j" class="mt-3">
                      <v-text-field 
                        v-model="p.valor" 
                        :rules="nameRules" 
                        :counter="30" 
                        :label="p.etiqueta" 
                        :type="p.tipo === 'date' ? 'date' : 'text'"
                        required 
                        outlined
                        dense
                        :disabled="estaCargado(d.id)"
                      />
                    </div>

                    <!-- Mostrar datos ya cargados -->
                    <div v-if="estaCargado(d.id)" class="mt-3">
                      <p class="text-caption grey--text">Datos actuales:</p>
                      <v-simple-table dense>
                        <template v-slot:default>
                          <tbody>
                            <tr v-for="(campoCargado, k) in obtenerDatosCargados(d.id)" :key="k">
                              <td class="text-caption">{{ campoCargado.etiqueta }}:</td>
                              <td class="text-caption"><strong>{{ campoCargado.valor }}</strong></td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Botones de navegación -->
                <div class="d-flex justify-space-between">
                  <v-btn 
                    outlined 
                    @click="activeStep = i"
                    :disabled="i === 0"
                  >
                    Atrás
                  </v-btn>

                  <v-btn 
                    color="primary" 
                    @click="activeStep = i + 2"
                    :disabled="!validarPaso(d) && !estaCargado(d.id)"
                  >
                    {{ i + 1 === datos.length ? 'Finalizar' : 'Siguiente' }}
                  </v-btn>
                </div>
              </v-stepper-content>
            </template>
          </v-stepper>
          </div>

          <p class="my-2 text-center red--text">{{ msg }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="red" :loading="loading" outlined @click="dialog = false">Cerrar</v-btn>
          <v-spacer />
          <v-btn 
            color="green" 
            :loading="loading" 
            outlined 
            @click="validar()"
            :disabled="todosCargados()"
          >
            {{ todosCargados() ? 'Todos los documentos cargados' : 'Registrar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL PARA VER DOCUMENTOS CARGADOS -->
    <v-dialog v-model="verDocumentosDialog" width="700" persistent>
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          Documentos Cargados
          <v-spacer />
          <v-btn color="white" text @click="verDocumentosDialog = false">X</v-btn>
        </v-card-title>
        
        <v-card-text class="pa-4">
          <v-list>
            <v-list-item 
              v-for="(cargado, index) in cargados" 
              :key="index"
              class="mb-2"
            >
              <v-list-item-icon>
                <v-icon color="green">mdi-check-circle</v-icon>
              </v-list-item-icon>
              
              <v-list-item-content>
                <v-list-item-title>
                  {{ cargado.documentoPersona.tipoDocumentoPersona.nombre }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  Estado: {{ cargado.documentoPersona.estadoRevision }}
                  • Fecha: {{ formatFecha(cargado.creadoEn) }}
                </v-list-item-subtitle>
                
                <!-- Datos del documento -->
                <div class="mt-2">
                  <v-chip
                    v-for="(dato, idx) in cargado.documentoPersona.datos"
                    :key="idx"
                    small
                    class="mr-1 mb-1"
                    color="primary"
                    text-color="white"
                  >
                    {{ dato.etiqueta }}: {{ dato.valor }}
                  </v-chip>
                </div>
              </v-list-item-content>
              
              <v-list-item-action>
                <v-btn 
                  icon 
                  small 
                  @click="descargarArchivo(cargado.documentoPersona.archivo)"
                  color="primary"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="verDocumentosDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Ups ref="refUps" />
  </div>
</template>

<script>
// import { ref } from 'vue';
import Ups from './subidos.vue';

export default {
  components: { Ups },
  data() {
    return {
      dialog: false,
      verDocumentosDialog: false,
      valid: false,
      loading: false,
      index: 0,
      inscripcion: {},
      datos: [],
      cargados: [],
      msg: '',
      activeStep: 1,
      nameRules: [(v) => !!v || 'requerido']
    };
  },
  methods: {
    openmodal(ins) {
      this.inscripcion = ins;
      this.datos = [];
      this.cargados = [];
      this.msg = '';
      this.index += 1;
      this.dialog = true;
      this.activeStep = 1;
      this.getRequisitos();
    },

    // MÉTODOS PARA MANEJAR DOCUMENTOS CARGADOS
    estaCargado(tipoDocumentoId) {
      return this.cargados.some(c => 
        c.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId
      );
    },

    obtenerEstado(tipoDocumentoId) {
      const cargado = this.cargados.find(c => 
        c.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId
      );
      return cargado ? cargado.documentoPersona.estadoRevision : 'pendiente';
    },

    obtenerDatosCargados(tipoDocumentoId) {
      const cargado = this.cargados.find(c => 
        c.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId
      );
      return cargado ? cargado.documentoPersona.datos : [];
    },

    obtenerArchivoUrl(tipoDocumentoId) {
      const cargado = this.cargados.find(c => 
        c.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId
      );
      if (cargado && cargado.documentoPersona.archivo) {
        // Aquí deberías construir la URL para descargar/ver el archivo
        // Esto depende de tu API
        return `/api/archivos/${cargado.documentoPersona.archivo.id}`;
      }
      return null;
    },

    obtenerTipoArchivo(tipoDocumentoId) {
      const cargado = this.cargados.find(c => 
        c.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId
      );
      if (cargado && cargado.documentoPersona.archivo) {
        const mimeType = cargado.documentoPersona.archivo.mimetype;
        if (mimeType.startsWith('image/')) return 'image';
        if (mimeType === 'application/pdf') return 'pdf';
      }
      return null;
    },

    todosCargados() {
      return this.datos.length > 0 && this.datos.every(d => this.estaCargado(d.id));
    },

    openVer() {
      this.verDocumentosDialog = true;
    },

    formatFecha(fecha) {
      return new Date(fecha).toLocaleDateString('es-ES');
    },

    descargarArchivo(archivo) {
      // Implementar lógica de descarga
      window.open(`/api/archivos/${archivo.id}`, '_blank');
    },

    // ... (los demás métodos se mantienen igual)
    setterFile(e, d) {
      d.archivo = e;
      if (e) {
        d.previewUrl = URL.createObjectURL(e);
      } else {
        d.previewUrl = null;
      }
    },

    async getRequisitos() {
      this.loading = true;
      const url = process.env.VUE_APP_URL_DOCUMENTOS + '/tipos-documentos-persona';
      try {
        const res = await fetch(url).then((r) => r.json());
        this.datos = res.datos.map((d) => ({ 
          ...d, 
          previewUrl: null,
          archivo: null 
        }));
        await this.findCargados();
        
        this.$nextTick(() => {
          this.activeStep = 1;
        });
      } catch (err) {
        window.console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async findCargados() {
      this.loading = true;
      const url =
        process.env.VUE_APP_URL_DOCUMENTOS +
        '/inscripciones-documentos-personas/inscripciones/' +
        this.inscripcion.id;
      try {
        const res = await fetch(url).then((r) => r.json());
        if (res.datos) {
          this.cargados = res.datos;
          
          // Pre-cargar los datos en los campos correspondientes
          this.precargarDatos();
        }
      } catch (err) {
        window.console.error(err);
      } finally {
        this.loading = false;
      }
    },

    precargarDatos() {
      this.datos.forEach(dato => {
        const cargado = this.cargados.find(c => 
          c.documentoPersona.tipoDocumentoPersonaId === dato.id
        );
        
        if (cargado) {
          // Pre-cargar los valores en los campos
          dato.plantillaDatos.forEach(campo => {
            const datoCargado = cargado.documentoPersona.datos.find(d => d.id === campo.id);
            if (datoCargado) {
              campo.valor = datoCargado.valor;
            }
          });
        }
      });
    },

    validarPaso(d) {
      if (this.estaCargado(d.id)) return true;
      if (!d.archivo) return false;
      
      for (const p of d.plantillaDatos) {
        if (!p.valor) return false;
      }
      
      return true;
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = (error) => reject(error);
      });
    },

    async validar() {
      this.msg = '';
      const documentosPersonas = [];

      for (let i = 0; i < this.datos.length; i++) {
        const d = this.datos[i];
        
        // Si ya está cargado, saltar
        if (this.estaCargado(d.id)) continue;
        
        if (!d.archivo) {
          this.msg = `Falta el archivo de: ${d.nombre}`;
          this.activeStep = i + 1;
          return;
        }

        for (const p of d.plantillaDatos) {
          if (!p.valor) {
            this.msg = `Falta el valor de: ${p.etiqueta} en ${d.nombre}`;
            this.activeStep = i + 1;
            return;
          }
        }

        const archivoBase64 = await this.fileToBase64(d.archivo);

        documentosPersonas.push({
          tipoDocumentoPersonaId: d.id,
          datos: d.plantillaDatos,
          archivoBase64
        });
      }

      // Si no hay documentos nuevos para subir
      if (documentosPersonas.length === 0) {
        this.msg = 'Todos los documentos ya están cargados';
        return;
      }

      const body = JSON.stringify({ documentosPersonas });

      this.loading = true;
      const url =
        process.env.VUE_APP_URL_DOCUMENTOS +
        '/inscripciones-documentos-personas/inscripciones/' +
        this.inscripcion.id;

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body
        }).then((r) => r.json());

        if (res.errores) {
          this.msg = Object.values(res.errores).flat().join(', ');
        } else {
          this.msg = res.mensaje || 'Documentos registrados con éxito';
          // Recargar los documentos cargados
          await this.findCargados();
          this.dialog = false;
        }
      } catch (err) {
        this.msg = 'Error al enviar los documentos';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>